<script setup lang="ts">
import { computed, defineProps } from 'vue'
import { formatDateForDisplay, getTimeRemaining } from '@/utils/dateUtils'

const props = defineProps({
  deadline: {
    type: Object as () => Date,
    required: true,
  },
  withDate: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const timeStatus = computed(() => getTimeRemaining(props.deadline))

const timeDisplay = computed(() => {
  switch (true) {
    case timeStatus.value < -1:
      return 'Il y a ' + -timeStatus.value + ' jours'
    case timeStatus.value === -1:
      return 'Hier'
    case timeStatus.value === 0:
      return "Aujourd'hui"
    case timeStatus.value === 1:
      return 'Demain'
    default:
      return 'Dans ' + timeStatus.value + ' jours'
  }
})

const getBadge = computed(() => {
  switch (true) {
    case timeStatus.value < 0:
      return 'badge-warning'
    case timeStatus.value == 0:
      return 'badge-accent'
    default:
      return 'badge-secondary'
  }
})
</script>

<template>
  <div :class="'badge mt-1 ' + getBadge">
    <p v-if="withDate" class="mr-2">{{ formatDateForDisplay(deadline) }}</p>
    {{ timeDisplay }}
  </div>
</template>
